import React from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import {
  ProfileFieldGrid,
  ProfileFieldRow,
  ProfileFieldRowTitle,
  ProfileInsuranceWrapper,
  ProfilePendingFailureInsuranceMessage,
} from "./Profile.styles";
import { GetTypographyContent } from "../shared/Typography/Typography";
import { getUserProfile } from "../../recoil/selectors";
import { dateFormatter } from "../../utils/helpers";
import { WarningRounded } from "../../assets/iconComponents/WarningRounded";
import { PhiInsuranceStatus } from "../../recoil/types";

export const ProfileInsurance = (): React.ReactElement => {
  const { t } = useTranslation();
  const profileInfo = useRecoilValue(getUserProfile);
  return (
    <>
      {profileInfo && (
        <>
          <ProfileInsuranceWrapper>
            {GetTypographyContent({
              content: t("profile.insurance.title"),
              size: "h3",
              textColor: "greyMedium",
              isBold: true,
            })}
            {profileInfo?.ins_status === PhiInsuranceStatus.Pending ? (
              <ProfilePendingFailureInsuranceMessage failure={false}>
                <WarningRounded />
                {t("profile.insurance.pendingReview")}
              </ProfilePendingFailureInsuranceMessage>
            ) : (
              <ProfileFieldGrid>
                <ProfileFieldRow>
                  <ProfileFieldRowTitle>
                    {t("profile.insurance.fields.insuranceProvider")}
                  </ProfileFieldRowTitle>
                  <ProfileFieldRow>
                    {GetTypographyContent({
                      content: profileInfo?.ins_provider || "",
                      size: "medium",
                      textColor: "black",
                    })}
                  </ProfileFieldRow>
                </ProfileFieldRow>
                <ProfileFieldRow>
                  <ProfileFieldRowTitle>
                    {t("profile.insurance.fields.memberId")}
                  </ProfileFieldRowTitle>

                  {GetTypographyContent({
                    content: profileInfo?.ins_number || "",
                    size: "medium",
                    textColor: "black",
                  })}
                </ProfileFieldRow>
                <ProfileFieldRow>
                  <ProfileFieldRowTitle>
                    {t("profile.insurance.fields.relationshipToPolicyOwner")}
                  </ProfileFieldRowTitle>
                  <ProfileFieldRow>
                    {GetTypographyContent({
                      content: profileInfo?.relationship_to_insured || "",
                      size: "medium",
                      textColor: "black",
                    })}
                  </ProfileFieldRow>
                </ProfileFieldRow>
                <ProfileFieldRow>
                  <ProfileFieldRowTitle>
                    {t("profile.insurance.fields.policyOwnerName")}
                  </ProfileFieldRowTitle>

                  {GetTypographyContent({
                    content: profileInfo?.subscriber_name || "",
                    size: "medium",
                    textColor: "black",
                  })}
                </ProfileFieldRow>
                <ProfileFieldRow>
                  <ProfileFieldRowTitle>
                    {t("profile.insurance.fields.groupId")}
                  </ProfileFieldRowTitle>
                  <ProfileFieldRow>
                    {GetTypographyContent({
                      content: profileInfo?.ins_group || "",
                      size: "medium",
                      textColor: "black",
                    })}
                  </ProfileFieldRow>
                </ProfileFieldRow>
                <ProfileFieldRow>
                  <ProfileFieldRowTitle>
                    {t("profile.insurance.fields.policyOwnerDateOfBirth")}
                  </ProfileFieldRowTitle>
                  {GetTypographyContent({
                    content: profileInfo?.subscriber_date_of_birth
                      ? dateFormatter(profileInfo?.subscriber_date_of_birth)
                      : "",
                    size: "medium",
                    textColor: "black",
                  })}
                </ProfileFieldRow>
              </ProfileFieldGrid>
            )}
          </ProfileInsuranceWrapper>
        </>
      )}
    </>
  );
};
